module.exports = __webpack_public_path__ + "static/media/AjusteEstoque2.d96bd932.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancAjusteEstoque/AjusteEstoque2.png
// module id = 2050
// module chunks = 0